import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SocialAuthService, SocialAuthServiceConfig } from './socialauth.service';
import { GoogleButtonDirective } from './directives/google-button.directive';
import { AppleButtonDirective } from './directives/apple-button.directive';
import { LoginButtonDirective } from './directives/login-button.directive';
/**
 * The main module of angularx-social-login library.
 */
@NgModule({
  imports: [CommonModule, GoogleButtonDirective, AppleButtonDirective, LoginButtonDirective],
  providers: [SocialAuthService],
  exports: [GoogleButtonDirective, AppleButtonDirective, LoginButtonDirective]
})
export class SocialLoginModule {
  public static initialize(config: SocialAuthServiceConfig): ModuleWithProviders<SocialLoginModule> {
    return {
      ngModule: SocialLoginModule,
      providers: [
        SocialAuthService,
        {
          provide: 'SocialAuthServiceConfig',
          useValue: config
        }
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: SocialLoginModule) {
    if (parentModule) {
      throw new Error('SocialLoginModule is already loaded. Import it in the AppModule only');
    }
  }
}
